// Tickets Module Types

export enum TicketCategory {
  LEAK = 'LEAK',
  LIGHTING = 'LIGHTING',
  SECURITY = 'SECURITY',
  COMPLAINT = 'COMPLAINT',
  LOST_PET = 'LOST_PET',
  OTHER = 'OTHER'
}

export enum TicketStatus {
  NEW = 'NEW',
  IN_REVIEW = 'IN_REVIEW',
  IN_PROCESS = 'IN_PROCESS',
  RESOLVED = 'RESOLVED'
}

export interface TicketComment {
  id: string;
  userId: string;
  userName: string;
  text: string;
  date: string;
  isAdmin: boolean;
}

export interface Ticket {
  id: string;
  userId: string;
  /** Quien lo reportó y la unidad del reporte (en reportes previos, la principal del reportante). */
  userName?: string | null;
  unitId?: string | null;
  unitName?: string | null;
  title: string;
  description: string;
  category: TicketCategory;
  status: TicketStatus;
  date: string;
  updatedAt: string;
  attachmentUrl?: string;
  comments: TicketComment[];
}
